import { omit } from 'common/utils/array/omit'

export function fromParam(url?: string): Record<string, any> {
  // {min:100,max:200} <- ?min=100&max=200
  const documentSearch =
    typeof document === 'undefined' ? '' : document.location.search
  let str
  if (url) {
    const split = url.split('/')
    str = split[split.length - 1]
  }

  if (!str && !documentSearch) {
    return {}
  }
  // eslint-disable-next-line
  const urlString = (str || documentSearch).replace(/(^\?)/, '')

  // Return empty object if no query string
  if (!urlString || urlString.trim() === '') {
    return {}
  }

  try {
    const params = new URLSearchParams(urlString)
    const entries = params.entries() //returns an iterator of decoded [key,value] tuples
    const result: Record<string, string> = {}
    for (const [key, value] of entries) {
      // each 'entry' is a [key, value] tupple
      result[key] = value
    }
    return result
  } catch (e) {
    console.warn('Failed to parse query parameters:', urlString, e)
    return {}
  }
}

export function toParam(
  obj?: Record<string, any>,
  options?: { arrayFormat?: 'comma' | 'repeat' },
): string {
  // {min:100,max:200} -> ?min=100&max=200
  // Arrays can be serialized in two ways:
  // - 'comma' (default): {company: ['A', 'B']} -> company=A,B
  // - 'repeat': {company: ['A', 'B']} -> company=A&company=B
  if (!obj) return ''
  const arrayFormat = options?.arrayFormat || 'comma'
  const allDefined = omit(
    obj,
    Object.keys(obj).filter(
      (key) => typeof obj[key] === 'undefined' || obj[key] === null,
    ),
  )
  const params: string[] = []

  Object.keys(allDefined).forEach((k) => {
    // @ts-ignore
    const val = allDefined[k]
    if (Array.isArray(val)) {
      if (arrayFormat === 'repeat') {
        // Serialize arrays as multiple parameters with the same name
        val.forEach((item) => {
          params.push(`${encodeURIComponent(k)}=${encodeURIComponent(item)}`)
        })
      } else {
        // Serialize arrays as comma-separated values (backwards compatible)
        params.push(
          `${encodeURIComponent(k)}=${encodeURIComponent(val.join(','))}`,
        )
      }
    } else {
      params.push(`${encodeURIComponent(k)}=${encodeURIComponent(val)}`)
    }
  })

  return params.join('&')
}
